<template>
  <div>
    <div class="row">
      <v-col class="d-flex flex-row">
        <div class="template" @click="catalog.ca_template = 1">
          <div
            class="template1 withpointer"
            :class="catalog.ca_template===1?'template-selected':''"
          ></div>
          <div class="template-legende">Catalogue PDF</div>
        </div>
        <div class="ml-3 template" @click="catalog.ca_template = 4">
          <div
            class="template4 withpointer"
            :class="catalog.ca_template===4?'template-selected':''"
          ></div>
          <div class="template-legende">
            Catalogue PDF
            <br />pour impression maison
          </div>
        </div>
        <div class="ml-3 template" @click="catalog.ca_template = 2">
          <div
            class="template2 withpointer"
            :class="catalog.ca_template===2?'template-selected':''"
          ></div>
          <div class="template-legende">Fichier Excel vente</div>
        </div>
      </v-col>
    </div>
    <div class="row">
      <v-col>
        <!-- <h3 class="h3">Option du template</h3>-->
        <hr />
        <v-row>
          <v-col cols="4">
            <m-form-text
              type="text"
              labelPosition="top"
              :name="$Utils.randomstring('name')"
              label="Nom du catalogue"
              v-model="catalog.ca_name"
            ></m-form-text>
          </v-col>
          <v-col cols="4">
            <m-form-select
              :name="$Utils.randomstring('template-lang')"
              :items="$store.state.items_catalog_languages"
              v-model="catalog.ca_lang"
              label="Langue"
              labelPosition="top"
            ></m-form-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col style="padding-bottom:0;">
            <v-expand-transition>
              <div v-if="catalog.ca_template==1 || catalog.ca_template==4">
                <v-checkbox hide-details label="Couverture" v-model="catalog.ca_cover"></v-checkbox>
                <v-expand-transition>
                  <v-row v-if="catalog.ca_cover">
                    <v-col cols="4" style="padding-bottom:0;">
                      <div class="inputs-texts-couverture">
                        <m-form-text
                          type="text"
                          labelPosition="top"
                          :name="$Utils.randomstring('text1')"
                          label="Textes"
                          placeholder="Titre catalogue ligne 1"
                          v-model="catalog.ca_text1"
                        ></m-form-text>
                        <m-form-text
                          type="text"
                          labelPosition="top"
                          :name="$Utils.randomstring('text2')"
                          placeholder="Titre catalogue ligne 2"
                          v-model="catalog.ca_text2"
                        ></m-form-text>
                        <m-form-text
                          type="text"
                          labelPosition="top"
                          :name="$Utils.randomstring('text3')"
                          placeholder="Titre catalogue ligne 3"
                          v-model="catalog.ca_text3"
                        ></m-form-text>
                        <m-form-text
                          type="textarea"
                          labelPosition="top"
                          :name="$Utils.randomstring('text4')"
                          placeholder="Table des matières / Index"
                          v-model="catalog.ca_text4"
                        ></m-form-text>
                      </div>
                    </v-col>
                    <v-col cols="4" class="d-flex flex-column px-6">
                      <div>Image</div>
                      <div class="container-img mt-3">
                        <div class="img">
                          <img
                            class="img-img"
                            v-if="catalog.ca_image"
                            :src="catalogImage.binary ? catalogImage.binary:$config.server_url+'/api/1.0/catalogs/image/'+catalog.ca_id+ '/1?token='+$store.state.token"
                            alt="image de couverture"
                          />
                        </div>
                      </div>
                      <v-btn
                        @click="editImg"
                        color="#2096f3"
                        small
                        depressed
                        class="btn-edit-img mt-3 primary2"
                      >Modifier l'image (format A4)</v-btn>
                      <input
                        hidden
                        type="file"
                        ref="inputImgCatalog"
                        name="imageCatalog"
                        accept="image/png, image/jpeg"
                        @change="changeImg"
                      />
                      <v-checkbox hide-details label="Supprimer l'image" v-model="deleteImage"></v-checkbox>
                    </v-col>
                    <v-col cols="4" class="d-flex flex-column px-6">
                      <div>Logo</div>
                      <div class="container-img mt-3">
                        <div class="img-logo d-flex">
                          <v-img
                            v-if="catalog.ca_logo"
                            :src="catalogLogo.binary ? catalogLogo.binary:$config.server_url+'/api/1.0/catalogs/image/'+catalog.ca_id+ '/2?token='+$store.state.token"
                            contain
                            height="150px"
                          ></v-img>
                        </div>
                      </div>
                      <v-btn
                        @click="editLogo"
                        color="#2096f3"
                        small
                        depressed
                        class="btn-edit-img mt-3 primary2"
                      >Modifier l'image (format carré)</v-btn>
                      <input
                        hidden
                        type="file"
                        ref="inputImgLogo"
                        name="imageLogo"
                        accept="image/png, image/jpeg"
                        @change="changeLogo"
                      />
                      <v-checkbox hide-details label="Supprimer l'image" v-model="deleteLogo"></v-checkbox>
                    </v-col>
                  </v-row>
                </v-expand-transition>
              </div>
            </v-expand-transition>
          </v-col>
        </v-row>
        <v-row>
          <v-col style="padding-bottom:0;">Pages d'introduction :</v-col>
        </v-row>
        <v-row v-if="catalog.ca_template==1 || catalog.ca_template==4" style="padding-top:0;">
          <v-col cols="2" style="padding-top:0;">
            <v-checkbox
              style="padding-top:0;"
              hide-details
              label="Entreprise"
              v-model="catalog.ca_intro_pages"
            ></v-checkbox>
          </v-col>
          <v-col cols="2" style="padding-top:0;">
            <v-checkbox
              style="padding-top:0;"
              hide-details
              label="Blanche"
              v-model="catalog.ca_white_page"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="catalog.ca_template==1 || catalog.ca_template==4" style="padding-top:0;">
            <v-checkbox
              hide-details
              label="Pages de séparation de familles"
              v-model="catalog.ca_separation_pages"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col style="padding-bottom:0;">Dernière de couverture :</v-col>
        </v-row>
        <v-row v-if="catalog.ca_template==1 || catalog.ca_template==4" style="padding-top:0;">
          <v-col cols="2" style="padding-top:0;">
            <v-checkbox
              style="padding-top:0;"
              hide-details
              label="France"
              v-model="catalog.ca_back_cover_france"
            ></v-checkbox>
          </v-col>
          <v-col cols="2" style="padding-top:0;">
            <v-checkbox
              style="padding-top:0;"
              hide-details
              label="Export"
              v-model="catalog.ca_back_cover_export"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-col>
    </div>
    <div class="row">
      <v-col class="d-flex flex-row">
        <v-spacer></v-spacer>
        <v-btn
          class="primary2--text"
          color
          text
          @click="this.$router.push('/catalogs')"
        >Reinitialiser</v-btn>
        <v-btn color="primary2" depressed @click="saveStep1()">Enregistrer</v-btn>
      </v-col>
    </div>
  </div>
</template>

<script>
export default {
  name: "catalogtemplate",
  props: {
    catalog: Object
  },
  data() {
    return {
      catalogImage: { image: null, binary: null },
      catalogLogo: { image: null, binary: null },
      deleteLogo: false,
      deleteImage: false,
      ca_id: 0,
      retourStep1: false,
      //// step 2 ////
      templateWaySelected: null,
      searchProduct: "",
      showProducts: false,
      // nbProducts: 0,
      // nbPages: 0,
      arborescence: {},
      fa_idToLoadProduct: 0,
      showProductsIgnore: false,
      retourStep2: false,

      //// step 3 ////
      retourStep3: false
    };
  },
  // filters: {},
  watch: {
    $route(to, from) {
      if (to.name === "catalogeditproducts") {
        //this.fa_idToLoadProduct = parseInt(to.params.fa_id);
        //this.showProducts = true;
      }
    },
    showProducts(val) {
      if (this.showProductsIgnore) return;

      if (val) {
        this.$router.push("/catalogs/edit/" + this.ca_id + "/products");
      } else {
        this.$router.push("/catalogs/edit/" + this.ca_id);
      }
    }
  },
  computed: {},
  components: {},
  async mounted() {},
  destroyed() {},
  methods: {
    editImg() {
      this.$refs.inputImgCatalog.click();
    },
    changeImg(e) {
      if (!e.target.files.length) return;
      this.catalogImage.image = e.target.files[0];
      var reader = new FileReader();
      var me = this;
      reader.onload = (function(theFile) {
        return function(e) {
          me.catalogImage.binary = e.target.result;
        };
      })(e.target.files[0]);
      reader.readAsDataURL(e.target.files[0]);
      this.catalog.ca_image = e.target.files[0].name;
    },
    editLogo() {
      this.$refs.inputImgLogo.click();
    },
    changeLogo(e) {
      if (!e.target.files.length) return;
      this.catalogLogo.image = e.target.files[0];
      var reader = new FileReader();
      var me = this;
      reader.onload = (function(theFile) {
        return function(e) {
          me.catalogLogo.binary = e.target.result;
        };
      })(e.target.files[0]);
      reader.readAsDataURL(e.target.files[0]);
      this.catalog.ca_logo = e.target.files[0].name;
    },
    async saveStep1() {
      if (
        (this.catalog.ca_template !== 1 &&
          this.catalog.ca_template !== 2 &&
          this.catalog.ca_template !== 4) ||
        this.catalog.ca_name == ""
      ) {
        alert("Merci de définir un template et un nom");
        return;
      }
      if (this.catalog.ca_intro_pages && this.catalog.ca_white_page) {
        alert(
          "Vous ne pouvez pas cocher les deux cases 'Pages d'introduction' et 'Page blanche après la couverture'"
        );
        return;
      }
      if (
        this.catalog.ca_back_cover_france &&
        this.catalog.ca_back_cover_export
      ) {
        alert(
          "Vous ne pouvez pas cocher les deux cases 'Der de couv france' et 'Der de cour export'"
        );
        return;
      }
      if (this.deleteImage) {
        this.catalog.ca_image = "";
        await this.$axios.delete(
          this.$config.server_url +
            "/api/1.0/catalogs/delete/imagecatalogs/" +
            this.catalog.ca_id +
            "-1"
        );
      }
      if (this.deleteLogo) {
        this.catalog.ca_logo = "";
        await this.$axios.delete(
          this.$config.server_url +
            "/api/1.0/catalogs/delete/imagecatalogs/" +
            this.catalog.ca_id +
            "-2"
        );
      }
      let responseCatalog = null;
      if (this.catalog.ca_id) {
        let response = await this.$axios.put(
          this.$config.server_url + "/api/1.0/catalogs/" + this.catalog.ca_id,
          this.catalog
        );
        responseCatalog = response.data.data;
      } else {
        let response = await this.$axios.post(
          this.$config.server_url + "/api/1.0/catalogs",
          this.catalog
        );
        // console.log("response.data.data", response.data.data);
        responseCatalog = response.data.data;
        this.$router.push("/catalogs/edit/" + response.data.data.ca_id);
      }
      if (this.catalogImage.image) {
        await this.saveImageCatalog(1, responseCatalog.ca_id);
      }
      if (this.catalogLogo.image) {
        await this.saveImageCatalog(2, responseCatalog.ca_id);
      }
      this.catalogImage = { image: null, binary: null };
      this.catalogLogo = { image: null, binary: null };
      this.$emit("setCatalog", responseCatalog);
    },
    async saveImageCatalog(num, ca_id) {
      let formData = new FormData();
      formData.append("ca_id", ca_id);
      if (num === 1)
        formData.append(
          "image",
          this.catalogImage.image,
          this.catalogImage.image.name
        );
      if (num === 2)
        formData.append(
          "image",
          this.catalogLogo.image,
          this.catalogLogo.image.name
        );
      await this.$axios.post(
        this.$config.server_url + "/api/1.0/catalogs/image/" + num,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );
    }
  }
};
</script>
<style  lang="scss" scoped>
.container-creation {
  background-color: #fff;
}
.create-catalog-step {
  padding: 8px;
  margin-bottom: 5px;
  align-items: center;
  cursor: pointer;
}
.background-yellow {
  background-color: #fdc90b;
  color: black;
}
.background-gray {
  background-color: #cccccc;
  color: #fff;
  .number-step {
    color: #cccccc;
  }
}
.number-step {
  background-color: #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  margin-right: 8px;
  font-size: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.title-step {
  font-size: 24px;
}

.template {
  display: flex;
  flex-direction: column;

  align-items: center;
}
.template1 {
  width: 150px;
  height: 200px;
  background-image: url(/img/template1.png);
  background-size: contain;
}
.template4 {
  width: 150px;
  height: 200px;
  background-image: url(/img/template4.png);
  background-size: contain;
}
.template2 {
  width: 150px;
  height: 200px;
  background-image: url(/img/template2.png);
  background-size: contain;
}
.template-selected {
  border: solid 3px #fdc90b;
}
.change-template-way {
  text-decoration: underline;
  color: #1f3b80;
}
.template-legende {
  text-align: center;
}
.inputs-texts-couverture {
  margin-left: 40px;
}
.icon-template {
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100px;
  .template-way-icon {
    width: 60px;
    height: 60px;
  }
}
#rozenbal .container-img {
  position: relative;
  width: 100%;
  height: 200px;
  border: solid 1px #ebebeb;
}
#rozenbal .container-img .img {
  width: 150px;
  height: 200px;
  margin-left: auto;
  margin-right: auto;
}
#rozenbal .container-img .img-img {
  width: 150px;
  height: 200px;
}
#rozenbal .container-img .img-logo {
  width: 220px;
  height: 200px;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
}

.template-way-legende {
  text-transform: uppercase;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
}
.btn-create-node {
  text-align: end;
}
///// col preview /////
.col-preview {
  width: 100%;
  // position: fixed;
}
.col-preview .v-image {
  box-shadow: 0 0px 5px 2px #cccccc;
  margin-left: auto;
  margin-right: auto;
}
.container-input-page {
  width: 70px;
}
.icon-gray {
  color: #cccccc;
}
.icon-black {
  color: black;
}
</style>